import Signin from './SignIn.vue';
import PasswordReset from './PasswordReset.vue';
import PasswordChange from './PasswordChange';

export default {
	Signin,
	PasswordReset,
	PasswordChange
}
